import { AppThunk } from '../../../../storage/store';
import { fetchStart, fetchSuccess, fetchFailed, setDownloadError } from './slice';
import { fetchVendorChargingReportAPI, downloadVendorChargingReportAPI } from './api';
import { VendorChargingReportFilters } from '../../model/vendorReports';
import { getToken } from '../../../../utils/auth';
import { triggerDownload } from '../../../../utils/download';

export const getVendorChargingReport = (filters: VendorChargingReportFilters = {}): AppThunk => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const token = getToken() || '';
    const data = await fetchVendorChargingReportAPI(token, filters);
    dispatch(fetchSuccess(data));
  } catch (err: any) {
    dispatch(fetchFailed(err?.message || 'Failed to load charging report.'));
  }
};

export const downloadVendorChargingReport = (filters: VendorChargingReportFilters = {}): AppThunk => async (dispatch) => {
  dispatch(setDownloadError(null));
  try {
    const token = getToken() || '';
    const { blob, filename } = await downloadVendorChargingReportAPI(token, filters);
    triggerDownload(blob, filename);
  } catch (err: any) {
    dispatch(setDownloadError(err?.message || 'Download failed. Please try again.'));
  }
};
